Auth = {
    reg: function () {
        var IDPrintMessage = '#sAuthMessage';

        S.printMessage(IDPrintMessage, 'hide');

        // var name = S.val('#iAuthName');
        var email = S.val('#iAuthEmail');
        var password = S.val('#iAuthPassword');
        var gReCaptchaResponse = S.val('#g-recaptcha-response');

        // var errorMessages = S.validator([
        //     [name, 'Введите имя.'],
        //     [email, 'Введите E-mail адрес.'],
        //     [password, 'Введите пароль.'],
        //     [gReCaptchaResponse, 'Поставьте галочку на против поля "Я не робот".']
        // ]);
        //
        // if (errorMessages.length > 0)
        // {
        //     S.printMessage(IDPrintMessage, 'error', S.messagesJoin(errorMessages));
        //
        //     return false;
        // }

        var btn = S.createAnimationButton('#bAuthReg');

        S.startAnimationButton(btn);

        S.ajax('register', {
            name: name,
            email: email,
            password: password,
            g_recaptcha_response: gReCaptchaResponse
        }, function (data) {
            try {
                if (typeof grecaptcha !== "undefined" && grecaptcha !== null) {
                    grecaptcha.reset();
                }

                if (data.error) {
                    switch (data.error.code) {
                        case 1: {
                            S.printMessage(IDPrintMessage, 'error', S.messagesJoin(data.error.data.messages));
                            break;
                        }

                        default: {
                            S.unknownErrorCode(data);
                        }
                    }
                } else if (data.success) {
                    switch (data.success.code) {
                        case 1: {
                            if (typeof yaCounter46974945 != 'undefined') {
                                yaCounter46974945.reachGoal('registraciyaa');
                            }

                            S.location('/panel');
                            break;
                        }

                        default: {
                            S.unknownSuccessCode(data);
                        }
                    }
                }
            } catch (e) {
                S.log(e);
            }
        }, function () {
            S.stopAnimationButton(btn);
        });
    },

    regNo: function () {
        S.location('/register/no2');
    },

    login: function () {
        var IDPrintMessage = '#sAuthMessage';

        S.printMessage(IDPrintMessage, 'hide');

        var email = S.val('#iAuthEmail');
        var password = S.val('#iAuthPassword');
        var gReCaptchaResponse = S.val('#g-recaptcha-response');

        var btn = S.createAnimationButton('#bAuthLogin');

        S.startAnimationButton(btn);

        S.ajax('login3', {
            email: email,
            password: password,
            g_recaptcha_response: gReCaptchaResponse
        }, function (data) {
            try {
                if (typeof grecaptcha !== "undefined" && grecaptcha !== null) {
                    grecaptcha.reset();
                }

                if (data.error) {
                    switch (data.error.code) {
                        case 1: {
                            S.printMessage(IDPrintMessage, 'error', S.messagesJoin(data.error.data.messages));
                            break;
                        }

                        default: {
                            S.unknownErrorCode(data);
                        }
                    }
                } else if (data.success) {
                    switch (data.success.code) {
                        case 1: {
                            S.location('/panel');
                            break;
                        }

                        default: {
                            S.unknownSuccessCode(data);
                        }
                    }
                }
            } catch (e) {
                S.log(e);
            }
        }, function () {
            S.stopAnimationButton(btn);
        });
    },

    reset: function () {
        var IDPrintMessage = '#sAuthMessage';

        S.printMessage(IDPrintMessage, 'hide');

        var email = S.val('#iAuthEmail');
        var gReCaptchaResponse = S.val('#g-recaptcha-response');

        var btn = S.createAnimationButton('#bAuthReset');

        S.startAnimationButton(btn);

        S.ajax('password/email', {
            email: email,
            g_recaptcha_response: gReCaptchaResponse
        }, function (data) {
            try {
                grecaptcha.reset();

                if (data.error) {
                    switch (data.error.code) {
                        case 1: {
                            S.printMessage(IDPrintMessage, 'error', S.messagesJoin(data.error.data.messages));
                            break;
                        }

                        default: {
                            S.unknownErrorCode(data);
                        }
                    }
                } else if (data.success) {
                    switch (data.success.code) {
                        case 1: {
                            S.printMessage(IDPrintMessage, 'success', S.messagesJoin(data.success.data.messages));
                            break;
                        }

                        default: {
                            S.unknownSuccessCode(data);
                        }
                    }
                }
            } catch (e) {
                S.log(e);
            }
        }, function () {
            S.stopAnimationButton(btn);
        });
    },

    setNewPassword: function (token) {
        var IDPrintMessage = '#sAuthMessage';

        S.printMessage(IDPrintMessage, 'hide');

        var password_1 = S.val('#iAuthPassword_1');
        var password_2 = S.val('#iAuthPassword_2');

        var btn = S.createAnimationButton('#bAuthReset');

        S.startAnimationButton(btn);

        S.ajax('password/reset', {
            token: token,
            password: password_1,
            password_confirmation: password_2
        }, function (data) {
            try {
                if (data.error) {
                    switch (data.error.code) {
                        case 1: {
                            S.printMessage(IDPrintMessage, 'error', S.messagesJoin(data.error.data.messages));
                            break;
                        }

                        default: {
                            S.unknownErrorCode(data);
                        }
                    }
                } else if (data.success) {
                    switch (data.success.code) {
                        case 1: {
                            S.printMessage(IDPrintMessage, 'success', S.messagesJoin(data.success.data.messages));
                            $('#containerAuth_1').hide();
                            $('#containerAuth_2').show();
                            break;
                        }

                        default: {
                            S.unknownSuccessCode(data);
                        }
                    }
                }
            } catch (e) {
                S.log(e);
            }
        }, function () {
            S.stopAnimationButton(btn);
        });
    }
};
